import React, { createContext, ReactNode, useContext } from "react";
import { LoadingIndicator } from "@jsq/ds/core";
import { GetComplianceCasesByObjectIdQueryResult } from "../../graphql/supergraph.index";

type RootProfileContextValue = {
  rootProfileId: number;
};

const RootProfileContext = createContext<RootProfileContextValue | undefined>(undefined);

export const useRootProfileContext = () => {
  const ctx = useContext(RootProfileContext);
  if (ctx === undefined) {
    throw new Error("useRootProfileContext must be used within an RootProfileContextProvider");
  }
  return ctx;
};
export interface RootProfileContextProviderProps {
  caseResult: GetComplianceCasesByObjectIdQueryResult;
  children: ReactNode;
}
export const RootProfileContextProvider = (props: RootProfileContextProviderProps) => {
  const { data, loading } = props.caseResult;

  if (loading) {
    return <LoadingIndicator variant="primary" />;
  }

  let value = {
    rootProfileId: 0,
  };

  if (data?.complianceCasesByObjectId?.[0]?.investingProfile?.id) {
    const rootProfileId = data?.complianceCasesByObjectId?.[0]?.investingProfile?.id;
    value = {
      rootProfileId,
    };
  }

  return (
    <RootProfileContext.Provider value={value}>{props.children}</RootProfileContext.Provider>
  );
};
